// Взято из исходников marked
const emailRe = /^[A-Za-z0-9._+-]+@[a-zA-Z0-9-_]+\.[a-zA-Z0-9-_]*[a-zA-Z0-9]$/;

export function hasProtocol(url = ''): boolean {
    return (/^[a-z]{2,}:\/\//i).test(url) || (/^mailto:/i).test(url);
}

function normalizeUrl(rawUrl: string): string {
    const trimmed = rawUrl.trim();

    if (emailRe.test(trimmed)) {
        return `mailto:${trimmed}`;
    }

    if (!hasProtocol(trimmed)) {
        return `https://${trimmed}`;
    }

    return trimmed;
}

function safeEncodeUrl(url: string): string {
    try {
        return encodeURI(decodeURI(url));
    } catch {
        return url;
    }
}

export function prepareForm(rawUrl: string, rawText = '') {
    const normalizedUrl = normalizeUrl(rawUrl);
    const url = safeEncodeUrl(normalizedUrl);
    const text = rawText.trim() || url.replace(/^mailto:/i, '');

    return {url, text};
}
